// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member_home[data-v-3a361bf6] {\n  overflow: hidden;\n  width: 100%;\n}\n.memberList[data-v-3a361bf6] {\n  width: 9.573333rem;\n  height: 1.92rem;\n  margin-left: 0.426667rem;\n}", ""]);
// Exports
module.exports = exports;
